import { render, staticRenderFns } from "./DraftMessageListTab.vue?vue&type=template&id=51cc4d70&scoped=true&lang=pug"
import script from "./DraftMessageListTab.vue?vue&type=script&lang=ts"
export * from "./DraftMessageListTab.vue?vue&type=script&lang=ts"
import style0 from "./DraftMessageListTab.vue?vue&type=style&index=0&id=51cc4d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc4d70",
  null
  
)

export default component.exports